
import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { Col, Row, Card, Button, Table, InputGroup, Form, Image, ButtonGroup, Dropdown } from "@themesberg/react-bootstrap";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faSearch, faDownload, faEdit, faEllipsisH, faExternalLinkAlt, faEye, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import Layout from "../../components/Layout";
import AddShelterModal from "../../components/StateOverview/AddShelterModal";
import EditShelterModal from "../../components/StateOverview/EditShelterModal";
import TableRow from "../../components/StateOverview/TableRow";
import { useAuth } from '../../Context/AuthContext';
import { BASE_URL } from "../../constants";
import { ToastContainer, Toast } from "react-bootstrap";
import ConfirmDeleteModal from '../../components/DeleteModal';
const ShelterByState = () => {
  const [rooms, setRooms] = useState([]);
   const [showEditModal, setShowEditModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const { user } = useAuth();
  const [selectedShelterId, setSelectedShelterId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedShelter, setSelectedShelter] = useState(null);
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  
   const [editForm, setEditForm] = useState({
    name: "",
    address: { street: "", postalCode: "", city: "", country: "" },
    capacity: "",
    numberRooms: "",
    contactInfo: { phone: "", email: "" },
    responsiblePerson: "",
    costPerOccupant: "",
    stateCoverage: ""
    });
  const [newShelter, setNewShelter] = useState({
      name: "",
      address: { street: "", postalCode: "", city: "", country: "" },
      capacity: "",
      numberRooms: "",
      contactInfo: { phone: "", email: "" },
      responsiblePerson: "",
      costPerOccupant: "",
      stateCoverage: ""
    });
    const [searchQuery, setSearchQuery] = useState("");
  
  const navigate = useNavigate();
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertVariant, setAlertVariant] = useState("success");
  
  const handleShowAlert = (message, variant = "success") => {
    setAlertMessage(message);
    setAlertVariant(variant);
    setShowAlert(true);
  };
  
  const handleViewDetails = (shelterId) => {
    navigate(`/shelters/shelterdetails/${shelterId}`);
  };

  useEffect(() => {
    const fetchRooms = async () => {
        setLoading(true);
      try {
        const response = await axios.get(`${BASE_URL}/shelters`);
        const formattedData = response.data.map((room) => ({
          ...room,
          avatar: room.responsiblePerson?.profilePhoto || "https://via.placeholder.com/40",
          capacity: {
            current: room.currentOccupants || 0,
            max: room.capacity || 100,
          },
          responsiblePerson: {
            firstName: room.responsiblePerson?.firstName || "No responsible",
            lastName: room.responsiblePerson?.lastName || "person",
          },
        }));

        setRooms(formattedData);
      } catch (error) {
        console.error("Error fetching rooms data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchRooms();
  }, []);

  // Filter rooms based on search query
const filteredRooms = rooms.filter((room) => {
  const fullName = `${room.responsiblePerson.firstName} ${room.responsiblePerson.lastName}`.toLowerCase();
  
  return (
    fullName.includes(searchQuery.toLowerCase()) ||  
    room.name.toLowerCase().includes(searchQuery.toLowerCase()) ||  
    room.address.toLowerCase().includes(searchQuery.toLowerCase())  
  );
});



 
const handleEdit = (room) => {
  setSelectedShelterId(room.id || room._id); // Ensure correct ID
  setEditForm({
    name: room.name,
    address: room.address || { street: "", postalCode: "", city: "", country: "" },
    capacity: room.capacity,
    numberRooms: room.numberRooms,
    contactInfo: room.contactInfo || { phone: "", email: "" },
    responsiblePerson: room.responsiblePerson || { firstName: "", lastName: "" },
    costPerOccupant: room.costPerOccupant,
    stateCoverage: room.stateCoverage,
  });
  setShowEditModal(true);
};




  const handleAddShelter = async () => {
    try {
      await axios.post(`${BASE_URL}/shelters`, newShelter);
      setShowAddModal(false);
      const response = await axios.get(`${BASE_URL}/shelters`);
      setRooms(response.data);
    } catch (error) {
      console.error("Error adding shelter:", error);
    }
  };

  const handleCloseModal = () => {
    setShowAddModal(false);
  };

  const exportData = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/shelters/export`, {
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "shelters_data.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error exporting shelter data:", error);
    }
  };
  const handleDeleteClick = (shelter) => {
    setSelectedShelter(shelter);
    setSelectedShelterId(shelter._id || shelter.id);
    setShowDeleteModal(true);
  };
  
  // Confirm delete
  const confirmDelete = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${BASE_URL}/shelters/${selectedShelterId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
  
     
      setRooms(prev => prev.filter(r => (r._id || r.id) !== selectedShelterId));
  
      setShowDeleteModal(false);
      setAlertMessage("Shelter deleted successfully!");
      setShowAlert(true);
    } catch (error) {
      console.error("Error deleting shelter:", error);
      setAlertMessage("Error deleting shelter.");
      setShowAlert(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
    <div>        
                <Row className="d-flex justify-content-between align-items-center py-3">
                <Col>
  <div className="btn-toolbar mb-2 mb-md-0">
    <InputGroup className="w-50">
      <InputGroup.Text>
        <FontAwesomeIcon icon={faSearch} />
      </InputGroup.Text>
      <Form.Control
        type="text"
        placeholder="Search"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
    </InputGroup>
  </div>
</Col>
    
                  {/* Export Button in ButtonGroup */}
                  <Col xs={12} md="auto" className="mb-2">
                    <div className="btn-toolbar mb-2 mb-md-0">
                      <ButtonGroup>
                        <Button variant="outline-cyan"  onClick={() => setShowAddModal(true)}>
                          <FontAwesomeIcon icon={faPlus} className="me-2" />
                          Add Shelter
                        </Button>
                        <Button variant="outline-cyan"  onClick={exportData}>
                          <FontAwesomeIcon icon={faDownload} className="me-2" />
                          Export All Shelters
                        </Button>
                      </ButtonGroup>
                    </div>
                  </Col>
                </Row>
                <AddShelterModal
                              show={showAddModal}
                              onHide={handleCloseModal}
                              newShelter={newShelter}
                              setNewShelter={setNewShelter}
                              handleAddShelter={handleAddShelter}
                            />
          {loading ? (
      <div className="text-center"></div>
    ) : filteredRooms.length > 0 ? (
            <Col md={12}>
              <Card border="light" className="shadow-sm">
                <Card.Body>
                <Table hover responsive>
                    <thead className="thead-light">
                      <tr>
                        <th>#</th>
                        <th>Responsible Person</th>
                        {/*<th>Capacity</th>
                        <th>Vacancy</th>*/}
                        <th>Shelter Name</th>
                        <th>Address</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody className="small">
  {filteredRooms.length > 0 ? (
    filteredRooms.map((room, index) => (
      <tr key={room.id}>
        <td>{index + 1}</td>
   <td>
  <div className="d-flex align-items-center">

    <span>{room.responsiblePerson.firstName} {room.responsiblePerson.lastName}</span>
  </div>
</td>

       {/* <td>{room.capacity.current} / {room.capacity.max}</td>
        <td>{room.capacity.max - room.capacity.current}</td>*/}
        <td>{room.name}</td>
        <td>
  {room.address 
    ? `${room.address.street}, ${room.address.postalCode} ${room.address.city}, ${room.address.country}`
    : "No address"}
</td>

<td>
  <Button
    variant="gray-500"
    size="sm"
    className="me-2"
    onClick={() => handleViewDetails(room.id)}
  >
    <FontAwesomeIcon icon={faEye} size="sm" />
  </Button>

  <Button
    variant="primary"
    size="sm"
    className="me-2"
    onClick={() => handleEdit(room)}
  >
    <FontAwesomeIcon icon={faEdit} size="sm" />
  </Button>

  <Button
    variant="danger"
    size="sm"
    onClick={() => handleDeleteClick(room)}
  >
    <FontAwesomeIcon icon={faTrashAlt} size="sm" />
  </Button>
</td>

<EditShelterModal
  show={showEditModal}
  setRooms={setRooms}   
  onHide={() => setShowEditModal(false)}
  shelterId={selectedShelterId}
  onShowAlert={handleShowAlert} 
  handleSaveChanges={(updatedShelter) => {
    setShowEditModal(false); 
  }}
/>

      </tr>    
    ))
  ) : (
    <tr>
      <td colSpan="6" className="text-center">No shelters found.</td>
    </tr>
  )}
</tbody>
  </Table>
                </Card.Body>
              </Card>
            </Col>
                 ) : null 
}
            
        </div>
                <ConfirmDeleteModal
                  show={showDeleteModal}
                  onClose={() => setShowDeleteModal(false)}
                  onConfirm={confirmDelete}
                  itemName={selectedShelter?.name || "this shelter"} 
                  loading={loading}
                />
        <ToastContainer position="top-end" className="p-3">
  <Toast
    onClose={() => setShowAlert(false)}
    show={showAlert}
    delay={3000}
    autohide
    bg={alertVariant}
  >
    <Toast.Body className="text-white">{alertMessage}</Toast.Body>
  </Toast>
</ToastContainer>

    </Layout>
  );
};


export default ShelterByState;